import { Injectable, OnDestroy, Signal, signal, WritableSignal } from '@angular/core';
import { QueryType } from '@app/modules/inputs/enums/query-type.enum';
import { QueryData } from '@app/modules/query/models/types/query-data.type';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: null
})
export class QueryStateService implements OnDestroy {

    private readonly _queryData: WritableSignal<QueryData> = signal<QueryData>(null);
    public queryData: Signal<QueryData> = this._queryData.asReadonly();

    private readonly _queryType: WritableSignal<QueryType> = signal<QueryType>(null);
    public queryType: Signal<QueryType> = this._queryType.asReadonly();

    private readonly _toggleQueryType: Subject<void> = new Subject<void>();
    public readonly toggleQueryType$: Observable<void> = this._toggleQueryType.asObservable();

    get inTransformerMode(): boolean {
        return this.queryData()?.transformerMode ?? false;
    }

    get isLoading(): boolean {
        return this.queryData()?.loading ?? true;
    }

    get isBasicMode(): boolean {
        return this.queryType() === QueryType.Basic;
    }

    setQueryData(data: QueryData): void {
        this._queryData.set(data);
    }

    patchQueryData(newData: Partial<QueryData>): void {
        this._queryData.update((currentData: QueryData) => ({
            ...currentData,
            ...newData
        }));
    }

    setQueryType(type: QueryType): void {
        this._queryType.set(type);
    }

    toggleQueryType(): void {
        this._toggleQueryType.next();
    }

    ngOnDestroy(): void {
        this._toggleQueryType.complete();
    }
}
